fourToldApp.controller('creditDetailsCntrl', function (xmppAuth, $http, services, esb, $location, $scope, $rootScope, $cookieStore, $cookies, $localStorage, $mdDialog, $window, $filter, $mdToast) {

    $scope.currentTab = 0;
    $scope.viewTemplate = $window.sessionStorage.getItem("viewTemplate");

    $scope.loan = ($window.sessionStorage.getItem("loanLocalData") != undefined && $window.sessionStorage.getItem("loanLocalData") != "undefined") ? JSON.parse($window.sessionStorage.getItem("loanLocalData")) : undefined;
    $scope.guarantorList = ($window.sessionStorage.getItem("loanGuarantors") != undefined && $window.sessionStorage.getItem("loanGuarantors") !=  "undefined") ? JSON.parse($window.sessionStorage.getItem("loanGuarantors")) : undefined;
    $scope.loan.loanDetails = ($window.sessionStorage.getItem("loanDetails") != undefined && $window.sessionStorage.getItem("loanDetails") !=  "undefined") ? JSON.parse($window.sessionStorage.getItem("loanDetails")) : undefined;
    $scope.loan.account = ($window.sessionStorage.getItem("account") != undefined  && $window.sessionStorage.getItem("account") != "undefined") ? JSON.parse($window.sessionStorage.getItem("account")) : undefined;
    $scope.loan.loanFees = ($window.sessionStorage.getItem("loanFees") != undefined && $window.sessionStorage.getItem("loanFees") != "undefined") ? JSON.parse($window.sessionStorage.getItem("loanFees")) : undefined;
    $scope.loan.createDate = new Date($scope.loan.createDate);

    console.log($scope.guarantorList);

    $scope.getDelayedPlans = function (plans) {
        delayedPlans = [];
        for (p of plans) {
            if ((p.payStatus != "Paid") && (p.delayDue > 0 || p.delayPaid > 0 || p.delayDays > 0)) {
                delayedPlans.unshift(p);
            }
        }
        return delayedPlans;
    }
    if ($scope.loan.loanDetails && $scope.loan.loanDetails.amortizationPlan != null) {
        if ($scope.loan.loanDetails.amortizationPlan.plan != null) {

            if($scope.loan.account != null && $scope.loan.account != "undefined") {
                $scope.loan.localBalance = $scope.loan.account.balance;
            } else {
                $scope.loan.localBalance = "0";
            }

            $scope.loan.loanDetails.nextPayment = $scope.loan.loanDetails.nextPayment ? $scope.loan.loanDetails.nextPayment : 0.0;
            $scope.loan.localLoanNext = $scope.loan.loanDetails.nextPayment;
        }
        //$scope.loan.loanDetails.nextPayment = $scope.loan.loanDetails.nextPayment;
        //$scope.loan.interestAmount = $scope.loan.interestAmount;

        $scope.loan.interest = $scope.loan.interest + " %";
        $scope.loan.periodInterest = $scope.loan.periodInterest + " %";
        $scope.loan.delayInterest = $scope.loan.delayInterest + " %";
        $scope.loan.localLoanNextDate = $scope.loan.loanDetails.nextPaymentDate ? new Date($scope.loan.loanDetails.nextPaymentDate) : "N/A";
        $scope.loan.localPaymentsDone = $scope.loan.loanDetails.paymentsDone + " / " + $scope.loan.duration;
        $scope.loan.loanDetails.amortizationPlan.delayedPlans = $scope.getDelayedPlans($scope.loan.loanDetails.amortizationPlan.plan);
        $scope.loan.feesRemaining = $scope.loan.duration - $scope.loan.loanDetails.paymentsDone;
        $scope.loan.totalAmount = $scope.loan.loanDetails.totalPaid + $scope.loan.loanDetails.totalDue;
        //$scope.loan.totalAmount = $scope.loan.totalAmount;
        //$scope.loan.loanDetails.authorizedLoanAmount = $scope.loan.loanDetails.authorizedLoanAmount;

        if ($scope.loan.loanDetails.amortizationPlan.delayedPlans.length > 0) {
            $scope.loan.delay = $scope.loan.loanDetails.totalDelayInterest > 0;
            $scope.loan.loanDetails.totalDelayInterest = $scope.loan.loanDetails.totalDelayInterest;
            $scope.loan.loanDetails.delayFee = $scope.loan.loanDetails.delayFee;
        }

        periodicity = "";
        switch ($scope.loan.periodicity) {
            case "WEEKLY":
                periodicity = "Semanal";
                break;
            case "TWO_WEEKS":
                periodicity = "14 días";
                break;
            case "BIWEEKLY":
                periodicity = "Quincenal";
                break;
            case "MONTHLY":
                periodicity = "Mensual";
                break;
            case "BIWEEKLY_FIXED":
                periodicity = "Mensual";
                break;            
            case 'DAILY':  
                periodicity = 'Diario'; break;
            case 'WEEKLY': 
                periodicity = 'Semanal'; break;
            case 'BIWEEKLY': 
                periodicity = 'Quincenal'; break;
            case 'MONTHLY':  
                periodicity = 'Mensual'; break;
            case 'TWO_MONTHLY': 
                periodicity = 'Bimestral'; break;
            case 'THREE_MONTHLY': 
                periodicity = 'Trimestral'; break;
            case 'SIX_MONTHLY': 
                periodicity = 'Semestral'; break;
            case 'ANNUAL': 
                periodicity = 'Anual'; break;
            case 'ONE_PAYMENT': 
                periodicity = 'Cuota única'; break;    
        }

        $scope.loan.periodicity = periodicity;

        $scope.fees = $scope.loan.loanFees;
        $scope.guarantors = $scope.loan.guarantors || [];
        $scope.plans = $scope.loan.loanDetails.amortizationPlan.plan;



    }

    $scope.changeTab = function (tabIndex) {
        $scope.currentTab = tabIndex;
    };

    $scope.actionCancel = function () {
        location.href = '#/' + $scope.viewTemplate;
    };

    $scope.openDocument = function (data, dataType) {
        $http.get(data, {
            responseType: 'arraybuffer'
        }).then(function (response) {
            var file = new Blob([response.data], {
                type: dataType
            });
            file.name = 'invoice.pdf';
            var fileUrl = URL.createObjectURL(file);
            $window.open(fileUrl, '_blank');
        });
    }

    $scope.convertArray = function (item) {
        //console.log(item);
        item = item.toString();
        item = item.replace('[', '');
        item = item.replace(']', '');
        item = item.replace(',', ', ');
        return item;
    };

    $scope.loadLoanDetails = function () {

    };

    $scope.loadFinConditions = function (customerId) {
        $scope.progress = "ok";
        $window.sessionStorage.setItem("viewTemplate", "clientsDashboard");
        $scope.finConditions = services.customers.customerServices("bearer " + $cookieStore.get("access_token")).finConditions({
            customerId: customerId
        }, function (response) {
            //console.log(response);
            $scope.progress = undefined;
        }, function (response) { }, function (error) {
            $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte técnico");
        });
    };

    $scope.startPaymentProcess = function (id) {
        $scope.progress = "data";
        $window.sessionStorage.setItem("viewTemplate", "clientsDashboard");
        services.credits.creditsServices(id).payCredit(function (response) {
            if (response.code === 1) {
                $window.sessionStorage.setItem("tokenPayment", response.token.id);
                $location.path("/inputPaymentOption");
            } else if (response.code === -500) {
                $scope.progress = undefined;
                $scope.showAlert("Ocurrio un error: code -500", "Pongase en contacto con soporte técnico");
            }
        });
    };

    $scope.elementAry = function (data) {
        $scope.elementHeaders = [];
        angular.forEach(data, function (val, key) {
            $scope.elementHeaders.push({
                key: key,
                val: val
            });
        });
        //console.log($scope.elementHeaders);
        return $scope.elementHeaders;
    };

    $scope.showInfo = function (data) {
        if (data == 1) {
            if ($scope.viewData.viewInfoDetails)
                $scope.viewData.viewInfoDetails = undefined;
            else
                $scope.viewData.viewInfoDetails = true;
            return $scope.viewData.viewInfoDetails;
        }
        if (data == 2) {
            if ($scope.viewData.viewInfoPayment)
                $scope.viewData.viewInfoPayment = undefined;
            else
                $scope.viewData.viewInfoPayment = true;
            return $scope.viewData.viewInfoPayment;
        }
        if (data == 3) {
            if ($scope.viewData.viewInfoCurrent)
                $scope.viewData.viewInfoCurrent = undefined;
            else
                $scope.viewData.viewInfoCurrent = true;

            return $scope.viewData.viewInfoCurrent;
        }
        if (data == 4) {
            if ($scope.viewData.viewInfoPersonal)
                $scope.viewData.viewInfoPersonal = undefined;
            else
                $scope.viewData.viewInfoPersonal = true;

            return $scope.viewData.viewInfoPersonal;
        }
        if (data == 5) {
            if ($scope.viewData.viewInfoFeedata)
                $scope.viewData.viewInfoFeedata = undefined;
            else
                $scope.viewData.viewInfoFeedata = true;

            return $scope.viewData.viewInfoFeedata;
        }
    }

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

});
